// extracted by mini-css-extract-plugin
module.exports = {"Content":"_10tXQ","ThemePurpleDark":"_2mxfT","Heading":"yKoFX","ThemeWhite":"_3Dgkg","Header":"_2VHtw","Copy":"_2r3uJ"};